// Ported from Telegram WebK (rvfc polyfill):
// https://github.com/ThaUnknown/rvfc-polyfill

/* eslint-disable @typescript-eslint/no-explicit-any */

(() => {
  if (typeof HTMLVideoElement === 'undefined') return;

  const proto: any = HTMLVideoElement.prototype;
  if ('requestVideoFrameCallback' in proto) return;
  if (!('getVideoPlaybackQuality' in proto)) return;

  proto._rvfcpolyfillmap = {};

  proto.requestVideoFrameCallback = function requestVideoFrameCallback(callback: any) {
    const quality = this.getVideoPlaybackQuality();
    const baseline = this.mozPresentedFrames
      || this.mozPaintedFrames
      || (quality.totalVideoFrames - quality.droppedVideoFrames);

    const handle = Date.now(); // spec says "long", can't reuse performance.now()
    const start = performance.now();

    const check = (old: number, now: number) => {
      const newquality = this.getVideoPlaybackQuality();
      const presentedFrames = this.mozPresentedFrames
        || this.mozPaintedFrames
        || (newquality.totalVideoFrames - newquality.droppedVideoFrames);

      if (presentedFrames > baseline) {
        const processingDuration = this.mozFrameDelay
          || (newquality.totalFrameDelay - quality.totalFrameDelay)
          || 0;
        const timediff = now - old; // HighRes diff

        callback(now, {
          presentationTime: now + processingDuration * 1000,
          expectedDisplayTime: now + timediff,
          width: this.videoWidth,
          height: this.videoHeight,
          mediaTime: Math.max(0, this.currentTime || 0) + timediff / 1000,
          presentedFrames,
          processingDuration
        });

        delete proto._rvfcpolyfillmap[handle];
      } else {
        proto._rvfcpolyfillmap[handle] = requestAnimationFrame((newer) => check(now, newer));
      }
    };

    proto._rvfcpolyfillmap[handle] = requestAnimationFrame((newer) => check(start, newer));
    return handle;
  };

  proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(handle: number) {
    cancelAnimationFrame(proto._rvfcpolyfillmap[handle]);
    delete proto._rvfcpolyfillmap[handle];
  };
})();

export {};

